/**
 * 基于jQuery的fixed插件
 * @param eleScrollLeft  两个值，true or false,默认true
 * @param ele 需要fixed的元素id
 * @param eleTopNum fixed的top值
 * @param eleAddClass 需要增加的类名
 * @param eleAddClassPar 父元素需要增加的类名
 * @param eleZindex fixed元素层级关系
 * @param elesOffsetTop 该属性只针对ele隐藏的情况，其他情况调用时不用加
 **/
$.fn.extend({
  commonFixed: function (options) {
    var isIE6 = !$.support.opacity && !$.support.style && window.XMLHttpRequest == undefined;
    if (isIE6) {
      return false;
    }

    var defaults = {
        //两个值，true or false,默认true
        eleScrollLeft: true,
        //需要fixed的元素id
        ele: '#commonFixedDiv',
        //fixid的top值
        eleTopNum: 0,
        //需要增加的类名
        eleAddClass: 'commonNavFixed',
        //父元素需要增加的类名
        eleAddClassPar: 'commonNavFixedPar',
        eleZindex: '99999',
        //该属性只针对ele隐藏的情况，其他情况调用时不用加
        elesOffsetTop: $(options.ele).offset().top - options.eleTopNum,
        eleHolderHeight: $(options.ele).outerHeight()
      },
      options = $.extend(defaults, options),
      $thisFixed = this,
      eles = $thisFixed.find(options.ele),
      eleTop = options.elesOffsetTop;

    var elesClone = $('<div></div>');
    elesClone.hide();
    elesClone.height(options.eleHolderHeight);
    // elesClone.width(eles.outerWidth());
    eles.after(elesClone);
    $(window).on('scroll', function () {
      var scrollTop = $(document).scrollTop();
      var scrollLeft = $(document).scrollLeft();
      var eleLeft = eles.parent().offset().left;
      if (options.eleScrollLeft) {
        eleLeft -= scrollLeft;
      }
      if (scrollTop > eleTop) {
        if (isIE6) {
          var sIE6 = options.eleTopNum;
          $('html').css({
            'background-image': 'url(about:blank)',
            'background-attachment': 'fixed'
          });
          eles.css({
            position: 'absolute',
            bottom: 'auto',
            top: document.documentElement.scrollTop + sIE6 + 'px',
            'z-index': options.eleZindex
          });
        } else {
          eles.css({
            position: 'fixed',
            top: options.eleTopNum + 'px',
            left: eleLeft,
            'z-index': options.eleZindex
          });
        }
        elesClone.show();
        eles.addClass(options.eleAddClass);
        eles.parent().addClass(options.eleAddClassPar);
      } else {
        elesClone.hide();
        eles.removeClass(options.eleAddClass);
        eles.parent().removeClass(options.eleAddClassPar);
        eles.css({
          position: '',
          top: '',
          bottom: '',
          left: '',
          'z-index': ''
        });
      }
    });
    $(window).on('resize', function () {
      $(window).trigger('scroll');
    });
  }
});



//////////////////
// WEBPACK FOOTER
// ./static/v4/js/fixed.js
// module id = 99371134645015ea1345
// module chunks = 1